import { Slider } from 'antd';
import { SliderMarks } from 'antd/es/slider';
import React, { useState } from 'react';
import styles from './WebsiteTrafficSlider.module.css';

export const WebsiteTrafficSlider = ({
  defaultValue,
  onChange,
}: {
  defaultValue?: number;
  onChange?: (value: number) => void;
}) => {
  const marks: SliderMarks = {
    0: '250',
    20: '500',
    40: '1,000',
    60: '2,000',
    80: '10,000',
    100: '25,000+',
  };
  const getMarkValue = (value: number) => {
    const markValueStr = String(marks?.[value])?.replace(/,/g, '');
    const markValueNum = parseInt(markValueStr, 10);
    return markValueNum;
  };

  const defaultValueKey = Object.keys(marks).find(
    key => getMarkValue(Number(key)) === defaultValue,
  );
  const [value, setValue] = useState(Number(defaultValueKey) || 0);

  return (
    <div className={styles.container}>
      <div className={styles.heading}>How Much Web Traffic Do You Have?</div>
      <Slider
        marks={marks}
        step={null}
        defaultValue={value}
        onChange={val => {
          setValue(val);
          const numberValue = getMarkValue(val);
          onChange?.(numberValue);
        }}
        tooltip={{ formatter: null }}
        className={styles.slider}
        trackStyle={{ backgroundColor: 'var(--color-geekblue-6)' }}
        railStyle={{ backgroundColor: '#CDDEF6' }}
      />
      <div className={styles.description}>
        <div className={styles.value}>
          {marks?.[value]?.toLocaleString('en-US')}
        </div>
        <div className={styles.text}>Unique website Visitors per Month</div>
      </div>
    </div>
  );
};
